"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ToastErrorContent = (props) => {
    return (react_1.default.createElement("div", { className: 'mt-4' },
        react_1.default.createElement("div", null,
            react_1.default.createElement("span", { className: 'font-bold' }, props.title)),
        props.children));
};
exports.default = ToastErrorContent;
